module.exports = "/img/banner.3d36933d.png";